class RedirectUserUseCase {
  private redirectUrl: string;

  constructor(redirectUrl: string) {
    this.redirectUrl = redirectUrl;
  }

  public execute(): void {
    window.location.href = this.redirectUrl;
  }
}

export default RedirectUserUseCase;
